<div class="menuSection">
  <div class="menuOuter">
    <div class="collapseControl">
      <nz-icon [nzType]="isMenuCollapsed ? 'menu-unfold' : 'menu-fold'" (click)="toggleCollapsed()" />
    </div>
    <div class="logo">
      <div class="logoContainer">
        <!-- #278572: el logo redirige al sitio web oficial del FNA (nueva pestaña, no pierde la sesión). -->
        <a
          class="logo d-flex justify-content-center"
          [href]="fnaWebsiteUrl"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Ir al sitio web oficial del FNA"
        >
          @if (!isMenuCollapsed || isMobileView) {
            <img
              class="logo-image-full ml-2"
              [src]="headerLogo || assetsBase + '/images/logos/horizontal-logo.png'"
              (error)="onHeaderLogoError()"
              alt="logo"
            />
          }
          @if (isMenuCollapsed && !isMobileView) {
            <img
              class="logo-image-small ml-1"
              [src]="compactLogo || assetsBase + '/images/logos/small-logo.png'"
              (error)="onCompactLogoError()"
              alt="logo"
            />
          }
        </a>
      </div>
    </div>
    <nz-divider></nz-divider>
    <div class="menuContainer">
      <div class="menuItems">
        <!-- [nzInlineCollapsed]="isMenuCollapsed && !isMobileView"> -->
        <ul
          nz-menu
          class="navigation"
          [nzInlineIndent]="15"
          nzMode="inline"
          [nzInlineCollapsed]="isMenuCollapsed && !isMobileView"
        >
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menuDataActivated, level: 0 }"></ng-container>
          <ng-template #menuTpl let-menuDataActivated let-level="level">
            @for (item of menuDataActivated; track $index) {
              @if (!item.roles || item.roles.includes(role)) {
                <ng-template #tooltipTpl>
                  {{ item.title }}
                </ng-template>
                <!-- group title item -->
                @if (item.category && !isMenuCollapsed && !isMobileView) {
                  <li nz-menu-group [nzTitle]="item?.title"></li>
                }
                <!-- disabled item -->
                @if (!item.category && item.disabled) {
                  <li
                    nz-menu-item
                    [nzSelected]="item.selected"
                    [nzDisabled]="true"
                    nz-tooltip
                    nzTooltipPlacement="right"
                    [nzTooltipTitle]="isMenuCollapsed && level === 0 ? tooltipTpl : ''"
                  >
                    <span [ngStyle]="{ 'padding-left.px': isMenuCollapsed ? '0' : level * 15 }">
                      @if (item.icon) {
                        <app-icon class="icon" [iconName]="item.icon"></app-icon>
                      }
                      @if (level !== 0 || !isMenuCollapsed) {
                        <span class="iconWrapper">
                          <span class="title">{{ item.title }}</span>
                          @if (item.count) {
                            <span class="badge badge-success ml-2">{{ item.count }}</span>
                          }
                        </span>
                      }
                    </span>
                  </li>
                }
                <!-- main item -->
                @if (!item.category && !item.children && (item.url || item.form)) {
                  <li
                    nz-menu-item
                    nz-tooltip
                    nzTooltipPlacement="right"
                    [nzSelected]="item.selected"
                    [nzDisabled]="item.disabled"
                    [nzTooltipTitle]="isMenuCollapsed && level === 0 ? tooltipTpl : ''"
                    (click)="openPage(item)"
                    (keydown.enter)="openPage(item)"
                    tabindex="0"
                    role="menuitem"
                  >
                    <span [ngStyle]="{ 'padding-left.px': isMenuCollapsed ? '0' : level * 15 }">
                      @if (item.icon) {
                        <app-icon class="icon" [iconName]="item.icon"></app-icon>
                      }
                      @if (level !== 0 || !isMenuCollapsed) {
                        <span class="iconWrapper">
                          <span class="title">{{ item.title }}</span>
                          @if (item.count) {
                            <span class="badge badge-success ml-2">{{ item.count }}</span>
                          }
                        </span>
                      }
                    </span>
                  </li>
                }
                <!-- submenu item with recursive template -->
                @if (!item.category && item.children) {
                  <li
                    nz-submenu
                    [nzOpen]="item.open && !isMenuCollapsed"
                    [nzTitle]="titleTpl"
                    nz-tooltip
                    nzTooltipPlacement="right"
                    [nzTooltipTitle]="isMenuCollapsed && level === 0 ? tooltipTpl : ''"
                  >
                    <ng-template #titleTpl>
                      @if (item.icon) {
                        <app-icon class="icon" [iconName]="item.icon"></app-icon>
                      }
                      @if (level !== 0 || !isMenuCollapsed) {
                        <span class="iconWrapper">
                          <span class="title">{{ item.title }}</span>
                          @if (item.count) {
                            <span class="badge badge-success ml-2">{{ item.count }}</span>
                          }
                        </span>
                      }
                    </ng-template>
                    <ul>
                      <ng-container
                        *ngTemplateOutlet="menuTpl; context: { $implicit: item.children, level: level + 1 }"
                      ></ng-container>
                    </ul>
                  </li>
                }
              }
            }
          </ng-template>
        </ul>
        <!-- BUG-274532: enlace visible a la política de privacidad pública. Google Play y App
             Store la exigen y la web debía ofrecerla igual; hasta ahora el único texto sobre
             tratamiento de datos era el habeas data embebido en el flujo de afiliación. -->
        <div class="menu-privacy">
          <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">
            <app-icon class="icon" iconName="lock"></app-icon>
            @if (!isMenuCollapsed) {
              <span class="title">Política de privacidad</span>
            }
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
